export const DEFAULT_AI_CONFIG = {
  provider: 'openai',
  apiKey: '',
  baseUrl: '',
  model: '',
  languages: [
    {
      id: 'en',
      label: 'English',
      prompt:
        'Translate the copy into polished English suitable for email marketing. Keep placeholders and HTML tags untouched.',
      locale: 'en-US',
    },
    {
      id: 'de',
      label: 'Deutsch',
      prompt:
        'Übersetze den Text ins Deutsche in höflicher Sie-Form. Erhalte HTML-Tags und Platzhalter.',
      locale: 'de-DE',
    },
    {
      id: 'fr',
      label: 'Français',
      prompt:
        'Traduire le contenu en français professionnel. Préserver les balises HTML et les variables dynamiques.',
      locale: 'fr-FR',
    },
    {
      id: 'ar',
      label: 'العربية',
      prompt:
        'ترجم النص إلى العربية الفصحى الحديثة مع الحفاظ على الوسوم والرموز الخاصة دون تغيير. استخدم صياغة مهنية مناسبة للبريد الإلكتروني.',
      locale: 'ar-SA',
    },
  ],
  snippetCategories: [
    {
      id: 'tone',
      label: 'Tone',
      description: 'Tone of voice adjustments.',
      options: [
        {
          id: 'tone-warm',
          label: 'Warm & friendly',
          prompt: 'Use a warm, friendly tone with positive, inclusive language.',
          tag: 'Warm',
        },
        {
          id: 'tone-formal',
          label: 'Formal',
          prompt: 'Use a formal, respectful tone suitable for senior stakeholders.',
          tag: 'Formal',
        },
      ],
    },
    {
      id: 'audience',
      label: 'Audience',
      description: 'Audience-specific guidance.',
      options: [
        {
          id: 'audience-delegates',
          label: 'Conference delegates',
          prompt: 'Write for international conference delegates who expect concise, informative updates.',
          tag: 'Delegates',
        },
        {
          id: 'audience-sponsors',
          label: 'Sponsors',
          prompt: 'Emphasise partnership value and ROI for potential sponsors.',
          tag: 'Sponsors',
        },
      ],
    },
  ],
  textTemplateQuickActions: [
    {
      label: 'Rewrite',
      actions: [
        {
          label: 'Professional',
          command: 'rewrite_full',
          prompt: 'Rewrite in a professional, confident tone.',
        },
        {
          label: 'Friendly',
          command: 'rewrite_full',
          prompt: 'Rewrite in a warm, friendly tone.',
        },
        {
          label: 'Executive',
          command: 'rewrite_full',
          prompt: 'Rewrite in a concise executive tone.',
        },
        {
          label: 'Casual',
          command: 'rewrite_full',
          prompt: 'Rewrite in a casual, approachable tone.',
        },
      ],
    },
    {
      label: 'Enhance',
      actions: [
        {
          label: 'Summarise',
          command: 'summarize',
          prompt: '',
        },
        {
          label: 'Expand',
          command: 'expand',
          prompt: '',
        },
        {
          label: 'Polish',
          command: 'improve',
          prompt: '',
        },
      ],
    },
  ],
};

export const ensureAiConfig = config => {
  if (!config || typeof config !== 'object') {
    return JSON.parse(JSON.stringify(DEFAULT_AI_CONFIG));
  }
  const provider = config.provider || DEFAULT_AI_CONFIG.provider;
  const apiKey = typeof config.apiKey === 'string' ? config.apiKey : DEFAULT_AI_CONFIG.apiKey;
  const baseUrl =
    typeof config.baseUrl === 'string' ? config.baseUrl : DEFAULT_AI_CONFIG.baseUrl;
  const model = typeof config.model === 'string' ? config.model : DEFAULT_AI_CONFIG.model;
  const languages =
    Array.isArray(config.languages) && config.languages.length > 0
      ? config.languages
      : DEFAULT_AI_CONFIG.languages;
  const snippetCategories =
    Array.isArray(config.snippetCategories) && config.snippetCategories.length > 0
      ? config.snippetCategories
      : DEFAULT_AI_CONFIG.snippetCategories;
  const textTemplateQuickActions =
    Array.isArray(config.textTemplateQuickActions) &&
    config.textTemplateQuickActions.length > 0
      ? config.textTemplateQuickActions
      : DEFAULT_AI_CONFIG.textTemplateQuickActions;
  return JSON.parse(
    JSON.stringify({
      ...config,
      provider,
      apiKey,
      baseUrl,
      model,
      languages,
      snippetCategories,
      textTemplateQuickActions,
    })
  );
};
